// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import PreferencesController from "./preferences_controller"
application.register("preferences", PreferencesController)

import GamesController from "./games_controller"
application.register("games", GamesController)

import RankingTeamLineController from "./ranking_team_line_controller"
application.register("ranking-team-line", RankingTeamLineController)
